module.exports = __webpack_public_path__ + "img/publication-3.129e482d.svg";